import { Navigate, useParams } from '@exam-center/router';

export default function ProctoringExamEventsPage() {
  const { examCenterCode, examEventId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId',
  );

  return (
    <Navigate
      to='/:examCenterCode/proctoring/exam-events/:examEventId/details'
      replace
      params={{ examCenterCode, examEventId }}
    />
  );
}
